import { connect } from 'react-redux'
import { formValueSelector } from 'redux-form/immutable'

import InputPhoneNumber from './InputPhoneNumber'

const getFieldName = prefixForField => (prefixForField ? `${prefixForField}phoneISO` : 'phoneISO')

const mapStateToProps = (state, ownProps) => ({
  selectedISO: formValueSelector(ownProps.form)(state, getFieldName(ownProps.prefixForField)),
})

export default connect(mapStateToProps)(InputPhoneNumber)
